import React, { useEffect } from 'react';
import UnifiedNavigation from '../../components/Navigation/UnifiedNavigation';
import Footer from '../../components/Footer/Footer';
import InstagramSection from '../../components/BrandHomePage/InstagramSection';
import { useScrollManager } from '../../hooks/useScrollManager';
import { useOverlayManager } from '../../contexts/OverlayContext';
import { initializeAllFeatures } from '../../utils/interactiveFeatures';
import './GettingHereIguazu.css';

const GettingHereIguazu: React.FC = () => {
  const { scrollState } = useScrollManager();
  const { setHoveredDestination } = useOverlayManager();

  useEffect(() => {
    window.scrollTo(0, 0);
    initializeAllFeatures();
    // Clear any lingering hover state to ensure correct footer variant
    setHoveredDestination(null);
  }, []);

  // Figma asset URLs
  const fullImage = '/assets/images/localhost/b511fc05b56f6f56ab808fe346dacf0108ddd079.png';
  const mapImage = '/assets/images/localhost/e81ab367ef65525aad1480d1faddeb5f7050ad91.png';
  const mapNavigation = '/assets/images/localhost/7480369bf8335012f137f5425989842c4b1fc8cf.png';
  const iguazuLogoSmall = '/assets/images/localhost/cb0c7d03b8fd9ce19313644f58103ee696e9624c.svg';
  const iguazuLogoSmall2 = '/assets/images/localhost/0501557fb03c945e93b7f590ca32f7a6f081cb88.svg';
  const markerArrow = '/assets/images/localhost/a33ba1312186de6cc92a2a3b035bfed60a30305c.svg';

  return (
    <div className="getting-here-iguazu">
      {/* Navigation - Iguazu variant (light) */}
      <UnifiedNavigation variant="light" destination="iguazu" />

      {/* Header Text Block */}
      <section className="getting-header-section" data-scroll-section>
        <div className="getting-header-content">
          <h1>How to get here</h1>
          <p>
            From Buenos Aires: LATAM and Aerolíneas Argentinas fly to International Airport of Puerto Iguazú (IGR). From destinations in Brazil: There are several flights a day from São Paulo, Rio de Janeiro and Porto Alegre to IGU. From Santiago: There is a flight from Santiago to IGU, available twice a week.
          </p>
        </div>
      </section>

      {/* Full Width Image */}
      <section className="getting-fullwidth-image" data-scroll-section>
        <div 
          className="fullwidth-image-container"
          style={{ backgroundImage: `url('${fullImage}')` }}
        />
      </section>

      {/* Map Section */}
      <section className="getting-map-section" data-scroll-section>
        <div className="map-section-container">
          {/* Map Image */}
          <div className="map-container">
            <div 
              className="map-image"
              style={{ backgroundImage: `url('${mapImage}')` }}
            >
              {/* Map Navigation Controls */}
              <div 
                className="map-navigation"
                style={{ backgroundImage: `url('${mapNavigation}')` }}
              />
              
              {/* Iguazu Location Marker */}
              <div className="map-marker">
                <div className="marker-tag">
                  <img src={iguazuLogoSmall} alt="Iguazu" className="marker-logo" />
                  <img src={iguazuLogoSmall2} alt="" className="marker-logo-overlay" />
                </div>
                <img src={markerArrow} alt="" className="marker-arrow" />
              </div>
            </div>
          </div>

          {/* Text Block */}
          <div className="map-text-block">
            <h2>Getting to Awasi Iguazú</h2>
            
            <div className="map-text-content">
              <div className="info-section">
                <h3>FROM BUENOS AIRES</h3>
                <p>Fly to Puerto Iguazú (IGR) - 20km / 30 min from Awasi</p>
              </div>

              <div className="info-section">
                <h3>FROM SAO PAULO OR RIO DE JANEIRO</h3>
                <p>
                  Fly to Foz de Iguaçu (IGU) - 17 km / 45 min from Awasi incl. border crossing. 
                  Awasi includes private transfers from and to Puerto Iguazú (IGR) or Foz de Iguaçu (IGU) airports, 
                  in accordance with our check in & check out times.
                </p>
              </div>

              <div className="divider-line"></div>

              <div className="info-section">
                <h3>OTHER AIRPORTS</h3>
                <p>
                  Our team can suggest different alternatives for transfers from other places. 
                  Other airports: Posadas (POS): 310 km / 4:00 hs
                </p>
              </div>

              <button className="contact-button">
                CONTACT US
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Transfer Information Block */}
      <section className="getting-transfer-section" data-scroll-section>
        <div className="transfer-content">
          <h2>
            There are no group transfers so the experience will be personalized and based on your pace.
          </h2>
          <button className="contact-button dark">
            CONTACT US
          </button>
        </div>
      </section>

      {/* Instagram Gallery */}
      <div className="instagram-section-wrapper">
        <InstagramSection />
      </div>

      {/* Footer - Iguazu variant */}
      <Footer variant="iguazu" />
    </div>
  );
};

export default GettingHereIguazu;